import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { CatalogTypeData } from 'gql/graphql';

import { useEffect, useMemo } from 'react';
import type { UseFormSetValue } from 'react-hook-form/dist/types/form';

import { getCatalogTypesGql } from '../createCatalogQueries';

export const CREATE_CATALOG_FIELD_NAME = 'createCatalogType';

export const useGetCatalogTypes = ({
    isOpen = false,
    setValue,
    currentValue,
}: {
    isOpen: boolean;
    setValue: UseFormSetValue<any>;
    currentValue: CatalogTypeData | undefined | null;
}) => {
    const [catalogTypes, getCatalogTypesStatus] = useRequest({
        requestId: 'catalogTypes',
        query: getCatalogTypesGql,
        withEffect: isOpen,
    });

    const [resetCatalogTypes] = useResetStoreData({ requestId: 'catalogTypes' });

    useEffect(() => {
        if (catalogTypes?.catalogTypes && !currentValue) {
            setValue(CREATE_CATALOG_FIELD_NAME, null);
        }
    }, [currentValue, catalogTypes?.catalogTypes, setValue]);

    useEffect(() => {
        if (!isOpen) {
            resetCatalogTypes(undefined);
        }
    }, [isOpen, resetCatalogTypes]);

    const temporarilyBlocked = useMemo(
        () =>
            catalogTypes?.catalogTypes.map((item, idx) => ({
                ...item,
                // TODO: сейчас есть только 2 справочника => блокируется через флаг. остальные до реализации хардкодом.
                disabled: idx > 1 || !item.canCreate,
            })),
        [catalogTypes?.catalogTypes],
    );

    return {
        catalogTypes: temporarilyBlocked,
        getCatalogTypesStatus,
    };
};
